import * as actionTypes from "./actionTypes";
import * as databaseBackupsService from "./service";

const log = require("loglevel").getLogger("databaseBackupsActions");
log.setLevel("debug");

export const snapshotToSandbox = (snapshotName, callback) => {
  return async (dispatch) => {
    log.debug("databaseBackupsActions -> snapshotToSandbox -> Enter");
    const result = await databaseBackupsService.snapshotToSandbox(snapshotName);

    if (result === "ok") {
      await dispatch(loadSnapshots());
    }

    callback?.(result);
  };
};

export const switchLiveDatabase = (id, dbType, callback) => {
  return async (dispatch) => {
    log.debug("databaseBackupsActions -> switchLiveDatabase -> Enter");
    const result = await databaseBackupsService.switchLiveDatabase(id, dbType);

    if (result === "ok") {
      await dispatch(loadSnapshots());
    }

    callback?.(result);
  };
};

export const createSnapshot = (comments, callback) => {
  return async (dispatch) => {
    log.debug("databaseBackupsActions -> createSnapshot -> Enter");
    const result = await databaseBackupsService.createSnapshot(comments);

    await dispatch(loadSnapshots());
    callback?.(result);
  };
};

export const removeSnapshot = (id, type, keepFinalBackup, callback) => {
  return async (dispatch) => {
    log.debug("databaseBackupsActions -> removeSnapshot -> Enter");
    const result = await databaseBackupsService.removeSnapshot(
      id,
      type,
      keepFinalBackup
    );

    callback?.(result);

    if (result === "ok") {
      await dispatch(loadSnapshots());
    }
  };
};

export const uploadData = (
  config,
  file,
  mappedFields,
  onlyValidate,
  callback
) => {
  return async (dispatch) => {
    log.debug("databaseBackupsActions -> uploadData -> Enter");
    const result = await databaseBackupsService.uploadData(
      config,
      file,
      mappedFields,
      onlyValidate
    );

    callback?.(result);
  };
};

export const loadSnapshots = (callback) => {
  return async (dispatch) => {
    log.debug("databaseBackupsActions -> loadSnapshots -> Enter");
    const snapshots = (await databaseBackupsService.loadSnapshots()) ?? [];

    // reload
    if (snapshots?.find((s) => s?.status !== "available")) {
      log.debug(
        "databaseBackupsActions -> loadSnapshots -> Refresh in 10 seconds"
      );
      callback?.();
    }

    log.debug("databaseBackupsActions -> loadSnapshots -> dispatch");
    await dispatch({
      type: actionTypes.SNAPSHOTS_LOADED,
      data: snapshots,
    });
  };
};
